import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "tailwindcss/tailwind.css";

import "./App.css";
import AppContainer from "../src/AppContainer";
import CookieConsent from "./components/CookieConsent";
import store from "./store/Store";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContainer />
        <CookieConsent />
      </Router>
    </Provider>
  );
}

export default App;
